import React from 'react';
import { mergeClassnames } from '../../utils/mergeClassnames';

interface VisualState {
  isSelected?: boolean;
  isDisabled?: boolean;
}

interface ChipProps {
  text: string;
  onClick?: () => void;
  id?: string;
  visualState?: VisualState;
}

const Chip: React.FC<ChipProps> = ({ text, onClick, id, visualState }) => {
  const baseClasses = [
    'chip-without-icon-vpadding',
    'chip-without-icon-hpadding',
    'chip-without-icon-radius',
    'chip-without-icon-font-family',
    'chip-without-icon-font-weight',
    'chip-without-icon-font-size',
    'chip-without-icon-line-height',
  ];

  let stateClasses: string[];

  if (visualState?.isDisabled) {
    stateClasses = [
      'chip-without-icon-disabled-bg',
      'chip-without-icon-disabled-text',
      'chip-without-icon-disabled-border',
    ];
  } else if (visualState?.isSelected) {
    stateClasses = [
      'chip-without-icon-selected-bg',
      'chip-without-icon-selected-text',
      'chip-without-icon-selected-border',
      'border border-[0.1rem]',
    ];
  } else {
    stateClasses = [
      'chip-without-icon-active-bg',
      'chip-without-icon-active-text',
      'chip-without-icon-active-border',
      'border border-[0.1rem]',
    ];
  }

  return (
    <button
      type="button"
      onClick={() => onClick?.()}
      className={mergeClassnames([...baseClasses, ...stateClasses])}
      id={id}
    >
      {text}
    </button>
  );
};

export default Chip;
